import * as React from 'react';
import * as style from './Seller.css';
import { Logo } from '../Logo';

import { INewbuildingBuilder, ISeller } from '../../../types/newbuilding/builder';
import { CallSeller } from '../../MobileCall/CallSeller';

interface ISellerProps {
  siteBlockId?: number | null;
  target: INewbuildingBuilder | ISeller;
  label: string;
  placeType: string;
  trackAction(builder: INewbuildingBuilder | ISeller): void;
}

export const Seller: React.FC<ISellerProps> = React.memo(({ target, label, placeType, siteBlockId, trackAction }) => {
  return (
    <div className={style['seller']}>
      <div className={style['seller-logo']}>
        <Logo
          // @ts-expect-error Свойство существует на одном из типов
          src={target.logoUrl || target.avatarUrl}
          name={target.name}
        />
      </div>
      <div className={style['seller-info']}>
        <div className={style['seller-title']}>
          <div className={style['seller-name']}>{target.name}</div>
          <div className={style['seller-label']}>{label}</div>
        </div>
        <div>
          {target.phone && (
            <CallSeller blockId={siteBlockId} target={target} placeType={placeType} trackAction={trackAction} />
          )}
        </div>
      </div>
    </div>
  );
});

Seller.displayName = 'Seller';
